"use client";

import { FilterContext } from "@faire/deprecated-retailer-visitor-shared/components/Filters/FilterContext";
import {
  FilterState,
  useCreateFilterStore,
} from "@faire/deprecated-retailer-visitor-shared/components/Filters/FilterStore";
import { useIsLoggedInRetailer } from "@faire/deprecated-retailer-visitor-shared/lib/isLoggedInRetailer";
import { SearchPageFiltersSetter } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageFilterContextProvider/SearchPageFiltersSetter";
import { useIsLoggedOutDiscoverPage } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useIsLoggedOutDiscoverPage";
import { useSearchPageQueryParams } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/SearchPageQueryParams/useSearchPageQueryParams";
import { getSelectedFilterKeys } from "@faire/retailer-shared/filters/getFilterOptions";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import React, { ReactNode, Suspense, useEffect } from "react";

export const SearchPageFilterContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { setFilters } = useSearchPageQueryParams();
  const { isDesktopAndAbove } = useViewport();
  const isLoggedOutDiscover = useIsLoggedOutDiscoverPage();
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const shouldCollapseSidebar =
    isDesktopAndAbove && (isLoggedInRetailer || isLoggedOutDiscover);

  const onFilterSelected = (filterState: FilterState) => {
    if (filterState.isNewFilterSelected) {
      const filterKeys = getSelectedFilterKeys(filterState.filterSections);
      setFilters(() => filterKeys, true);
    }
  };

  const filterStore = useCreateFilterStore(
    FilterState.build({
      ...(shouldCollapseSidebar ? { isSideBarVisible: false } : {}),
      shouldShowFilterCollapsePill: shouldCollapseSidebar,
      hideOptionsResultCount: shouldCollapseSidebar,
      filterSections: [],
    }),
    onFilterSelected
  );

  useEffect(() => {
    filterStore.setState((currentState) => ({
      ...currentState,
      shouldShowFilterCollapsePill: shouldCollapseSidebar,
      hideOptionsResultCount: shouldCollapseSidebar,
    }));
  }, [filterStore, shouldCollapseSidebar]);

  return (
    <FilterContext.Provider value={filterStore}>
      <Suspense fallback={null}>
        <SearchPageFiltersSetter />
      </Suspense>
      {children}
    </FilterContext.Provider>
  );
};
